import { computed } from 'vue'
import { useBooleanCookie } from '@/plugins/cookie-plugin'

export const useGridViewToggle = () => {
    const tableView = useBooleanCookie('stone_table_view_preference')
    const classCards = computed(() => ({
        'table-view': tableView.value,
    }))

    return {
        tableView,
        classCards,
    }
}
